<template id="app">
    <liquidationNew />
    </template>
    <script>
    import liquidationNew from "@/components/api/v2/reverse/liquidation/liquidationNew.vue";
    export default {
         components: {
          liquidationNew
        },
    created() {
        this.$store.commit("setActiveTab", { active_tab:'Closed'});
        }
    }
    </script>